<article class="w-full relative">
  <app-navbar></app-navbar>

  <app-gallery-project *ngIf="data.slug"
                       [data]="data">
  </app-gallery-project>

  <app-project-features *ngIf="data?.features?.length > 0"
                        [data]="data">
  </app-project-features>
  
  <app-gallery-information *ngIf="data?.data?.gallery?.length > 0"
                           [data]="data">
  </app-gallery-information>

  <app-gallery-banner *ngIf="data?.bannerId" [slug]="data?.bannerId" [color]="data?.color"></app-gallery-banner>

  <app-map-sensor [mapId]="data?.slug" [mapInfo]="data?.mapInfo" [color]="data?.color"></app-map-sensor>

  <app-footer [color]="data?.color"></app-footer>
</article>